import * as yup from 'yup';

export const updateData = yup.object().shape({
    title: yup.string(),
    members: yup.array(),
    // icon:
})